import { useMemo } from "react"
import { appConstants } from "../../appConstants"
import { BSParking } from "../../dto/beem-shot/BSParking/BSParking"
import { BSParkingCreationDto } from "../../dto/beem-shot/BSParking/BSParkingCreationDto"
import { BSParkingUpdateDto } from "../../dto/beem-shot/BSParking/BSParkingUpdateDto"
import { useHttp } from "../use-http"

type BSParkingHook = {
  getAllBSParking(bsBuildingId: string): Promise<BSParking[]>
  postBSParking(bsParkingCreationDto: BSParkingCreationDto): Promise<BSParking>
  putBSParking(bsParkingUpdateDto: BSParkingUpdateDto): Promise<BSParking>
  deleteBSParking(bsParkingId: string): Promise<Response>
}

export function useBSParking(): BSParkingHook {
  const { get, post, put, deleteRequest } = useHttp()

  return useMemo(
    () => ({
      postBSParking(bsParkingCreationDto: BSParkingCreationDto): Promise<BSParking> {
        return post(appConstants.apiEndpoints.BEEM_SHOT_PARKING, bsParkingCreationDto).then((response) => response.json())
      },
      putBSParking(bsParkingUpdateDto: BSParkingUpdateDto): Promise<BSParking> {
        return put(appConstants.apiEndpoints.BEEM_SHOT_PARKING, bsParkingUpdateDto).then((response) => response.json())
      },
      deleteBSParking(bsParkingId: string): Promise<Response> {
        return deleteRequest(appConstants.apiEndpoints.BEEM_SHOT_PARKING, [
          {
            key: "bsParkingId",
            value: bsParkingId,
          },
        ])
      },
      getAllBSParking(bsBuildingId: string): Promise<BSParking[]> {
        return get(appConstants.apiEndpoints.BEEM_SHOT_PARKING_LIST, [{ key: "bsBuildingId", value: bsBuildingId }]).then(
          (response) => response.json()
        )
      },
    }),
    [get, post, put, deleteRequest]
  )
}
